/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// redux
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import CustomerSearchForm from '../../components/_dashboard/customer-search/CustomerSearchForm';

// ----------------------------------------------------------------------

export default function CustomerSearch() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Customer Search | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Customer Search"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Customer Search', href: PATH_DASHBOARD.general.customer_search }
          ]}
        />
        <CustomerSearchForm />
      </Container>
    </Page>
  );
}
